import { render, staticRenderFns } from "./InputEmail.vue?vue&type=template&id=24afbab8&scoped=true&"
import script from "./InputEmail.vue?vue&type=script&lang=ts&"
export * from "./InputEmail.vue?vue&type=script&lang=ts&"
import style0 from "./InputEmail.vue?vue&type=style&index=0&id=24afbab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24afbab8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCard,VCardText,VForm,VTextField})
